import React, { type ReactNode, type Ref } from 'react';

import { IconButton, type IconButtonProps } from '@atlaskit/button/new';
import type { AnyEntryPoint } from '@atlassian/entry-point-types';

import { ModalTrigger, type ModalTriggerProps as ModalTriggerProps } from './modal-trigger';

export type ModalIconButtonTriggerProps<TEntryPoint> = Omit<
	ModalTriggerProps<TEntryPoint>,
	'children' | 'title'
> & {
	modalTitle?: ReactNode;
} & Omit<IconButtonProps, 'ref'>; // Prevent ref prop collision between ButtonProps and render prop

export function ModalIconButtonTrigger<TEntryPoint extends AnyEntryPoint>({
	entryPoint,
	entryPointParams,
	entryPointProps,
	Fallback,
	modalTitle,
	modalProps,
	forwardedRef,
	preloadOnFocus,
	loadingText,
	...buttonProps
}: ModalIconButtonTriggerProps<TEntryPoint>): React.JSX.Element {
	return (
		<ModalTrigger
			forwardedRef={forwardedRef}
			entryPoint={entryPoint}
			entryPointParams={entryPointParams}
			entryPointProps={entryPointProps}
			Fallback={Fallback}
			title={modalTitle}
			modalProps={modalProps}
			preloadOnFocus={preloadOnFocus}
			loadingText={loadingText}
		>
			{({ ref }) => (
				// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
				<IconButton ref={ref as Ref<HTMLButtonElement>} {...buttonProps} />
			)}
		</ModalTrigger>
	);
}
